<template>
  <v-card class="border-radius pa-2">
    <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header">
      Dokumen

      <v-spacer/>

      <v-icon 
        @click="$emit('screen', !fullscreen ? true : false)"
        class="cursor-pointer mr-1"
        size="24"
        :color="set_color">
        {{ !fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
      </v-icon>

      <v-icon 
        @click="reset()"
        class="cursor-pointer"
        size="24"
        color="red">
        mdi-close-circle-outline
      </v-icon>
    </v-card-title>

    <v-divider class="mx-4 mt-3 mb-2"/>

    <v-card-text 
      class="pt-2"
      style="height: 750px;">
      <ValidationObserver 
        ref="form_doc">
        <v-form>
          <div
            class="mb-6">
            <div class="body-2 mb-2">
              Upload KTP
            </div>

            <uploadfolder
              v-model="upload.ktp" 
              style="height: 300px;">
              <div 
                slot="activator"
                class="cursor-pointer">
                <v-card 
                  flat
                  height="300"
                  class="d-flex align-center justify-center"
                  style="border-radius: 15px;
                        border: 2px solid #eaeaea; 
                        border-style: dashed;">
                  <div v-if="form.ktp.length < 1">
                    <v-icon v-if="!process.ktp"
                      size="60" 
                      color="grey">
                      mdi-cloud-upload-outline
                    </v-icon>

                    <v-progress-circular v-else
                      indeterminate
                      :color="set_color">
                    </v-progress-circular>
                  </div>

                  <v-img v-else
                    contain
                    height="300"
                    :src="form.ktp" 
                    :alt="form.ktp"
                    class="text-center d-flex align-center">
                    <div 
                      class="d-flex aling-center justify-center" 
                      style="width: 100%; height: auto;">
                      <v-icon v-if="!process.ktp"
                        size="60" 
                        color="white">
                        mdi-cloud-upload-outline
                      </v-icon>

                      <v-progress-circular v-else
                        indeterminate
                        :color="set_color">
                      </v-progress-circular>
                    </div>
                  </v-img>
                </v-card>
              </div>
            </uploadfolder>
          </div>

          <div
            class="mb-6">
            <div class="body-2 mb-2">
              Upload KK
            </div>

            <uploadfolder
              v-model="upload.kk" 
              style="height: 300px;">
              <div 
                slot="activator"
                class="cursor-pointer">
                <v-card 
                  flat
                  height="300"
                  class="d-flex align-center justify-center"
                  style="border-radius: 15px;
                        border: 2px solid #eaeaea; 
                        border-style: dashed;">
                  <div v-if="form.kk.length < 1">
                    <v-icon v-if="!process.kk"
                      size="60" 
                      color="grey">
                      mdi-cloud-upload-outline
                    </v-icon>

                    <v-progress-circular v-else
                      indeterminate
                      :color="set_color">
                    </v-progress-circular>
                  </div>

                  <v-img v-else
                    contain
                    height="300"
                    :src="form.kk" 
                    :alt="form.kk"
                    class="text-center d-flex align-center">
                    <div 
                      class="d-flex aling-center justify-center" 
                      style="width: 100%; height: auto;">
                      <v-icon v-if="!process.kk"
                        size="60" 
                        color="white">
                        mdi-cloud-upload-outline
                      </v-icon>

                      <v-progress-circular v-else
                        indeterminate
                        :color="set_color">
                      </v-progress-circular>
                    </div>
                  </v-img>
                </v-card>
              </div>
            </uploadfolder>
          </div>

          <div
            class="mb-6">
            <div class="body-2 mb-2">
              Upload NPWP
            </div>

            <uploadfolder
              v-model="upload.npwp" 
              style="height: 300px;">
              <div 
                slot="activator"
                class="cursor-pointer">
                <v-card 
                  flat
                  height="300"
                  class="d-flex align-center justify-center"
                  style="border-radius: 15px;
                        border: 2px solid #eaeaea; 
                        border-style: dashed;">
                  <div v-if="form.npwp.length < 1">
                    <v-icon v-if="!process.npwp"
                      size="60" 
                      color="grey">
                      mdi-cloud-upload-outline
                    </v-icon>

                    <v-progress-circular v-else
                      indeterminate
                      :color="set_color">
                    </v-progress-circular>
                  </div>

                  <v-img v-else
                    contain
                    height="300"
                    :src="form.npwp" 
                    :alt="form.npwp"
                    class="text-center d-flex align-center">
                    <div 
                      class="d-flex aling-center justify-center" 
                      style="width: 100%; height: auto;">
                      <v-icon v-if="!process.npwp"
                        size="60" 
                        color="white">
                        mdi-cloud-upload-outline
                      </v-icon>

                      <v-progress-circular v-else
                        indeterminate
                        :color="set_color">
                      </v-progress-circular>
                    </div>
                  </v-img>
                </v-card>
              </div>
            </uploadfolder>
          </div>

          <div
            class="mb-6">
            <div class="body-2 mb-2">
              Upload BPJS Kesehatan
            </div>

            <uploadfolder
              v-model="upload.bpjs_kesehatan" 
              style="height: 300px;">
              <div 
                slot="activator"
                class="cursor-pointer">
                <v-card 
                  flat
                  height="300"
                  class="d-flex align-center justify-center"
                  style="border-radius: 15px;
                        border: 2px solid #eaeaea; 
                        border-style: dashed;">
                  <div v-if="form.bpjs_kesehatan.length < 1">
                    <v-icon v-if="!process.bpjs_kesehatan"
                      size="60" 
                      color="grey">
                      mdi-cloud-upload-outline
                    </v-icon>

                    <v-progress-circular v-else
                      indeterminate
                      :color="set_color">
                    </v-progress-circular>
                  </div>

                  <v-img v-else
                    contain
                    height="300"
                    :src="form.bpjs_kesehatan" 
                    :alt="form.bpjs_kesehatan"
                    class="text-center d-flex align-center">
                    <div 
                      class="d-flex aling-center justify-center" 
                      style="width: 100%; height: auto;">
                      <v-icon v-if="!process.bpjs_kesehatan"
                        size="60" 
                        color="white">
                        mdi-cloud-upload-outline
                      </v-icon>

                      <v-progress-circular v-else
                        indeterminate
                        :color="set_color">
                      </v-progress-circular>
                    </div>
                  </v-img>
                </v-card>
              </div>
            </uploadfolder>
          </div>

          <div
            class="mb-6">
            <div class="body-2 mb-2">
              Upload BPJS Ketenagakerjaan
            </div>

            <uploadfolder
              v-model="upload.bpjs_ketenagakerjaan" 
              style="height: 300px;">
              <div 
                slot="activator"
                class="cursor-pointer">
                <v-card 
                  flat
                  height="300"
                  class="d-flex align-center justify-center"
                  style="border-radius: 15px;
                        border: 2px solid #eaeaea; 
                        border-style: dashed;">
                  <div v-if="form.bpjs_ketenagakerjaan.length < 1">
                    <v-icon v-if="!process.bpjs_ketenagakerjaan"
                      size="60" 
                      color="grey">
                      mdi-cloud-upload-outline
                    </v-icon>

                    <v-progress-circular v-else
                      indeterminate
                      :color="set_color">
                    </v-progress-circular>
                  </div>

                  <v-img v-else
                    contain
                    height="300"
                    :src="form.bpjs_ketenagakerjaan" 
                    :alt="form.bpjs_ketenagakerjaan"
                    class="text-center d-flex align-center">
                    <div 
                      class="d-flex aling-center justify-center" 
                      style="width: 100%; height: auto;">
                      <v-icon v-if="!process.bpjs_ketenagakerjaan"
                        size="60" 
                        color="white">
                        mdi-cloud-upload-outline
                      </v-icon>

                      <v-progress-circular v-else
                        indeterminate
                        :color="set_color">
                      </v-progress-circular>
                    </div>
                  </v-img>
                </v-card>
              </div>
            </uploadfolder>
          </div>
        </v-form>
      </ValidationObserver>

      <div v-if="message.error.length > 0"
        class="text-center my-4">
        <div
          class="error--text d-flex align-center">
          <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
          
          <span
            class="ml-1">
            {{ message.error }}
          </span>
        </div>
      </div>
    </v-card-text>

    <v-divider class="mx-4 mb-3 mt-0"/>

    <v-card-actions>
      <v-spacer/>

      <v-btn
        color="green"
        elevation="0"
        style="border-radius: 10px;"
        class="body-2 font-weight-bold text-capitalize white--text"
        :disabled="process.form"
        :loading="process.form"
        v-on:keyup.enter="save()"
        @click="save()">
        <v-icon small class="mr-1">mdi-check-bold</v-icon>
        Simpan
      </v-btn>

      <v-btn
        outlined
        style="border-radius: 10px;"
        class="body-2 font-weight-bold text-capitalize red--text"
        :disabled="process.form"
        @click="reset()">
        <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
        Batal
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    props: {
      form: {
        type: Object,
        default: {}
      },
      fullscreen: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        upload: {
          ktp: null,
          kk: null,
          npwp: null,
          bpjs_kesehatan: null,
          bpjs_ketenagakerjaan: null
        },
        process: {
          ktp: false,
          kk: false,
          npwp: false,
          bpjs_kesehatan: false,
          bpjs_ketenagakerjaan: false,
          form: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetch: true */ '@/components/upload/folder.vue')
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      set_color () {
        return this.$store.state.color
      }
    },
    watch: {
      'upload.ktp': {
        handler: function () {
          if (this.upload.ktp) {
            this.process.ktp = this.upload.ktp.process

            if (!this.process.ktp) {
              // CALLBACK FROM UPLOAD DOC
              
              this.form.ktp = this.upload.ktp.fileuri
            }
          }
        },
        deep: true
      },
      'upload.kk': {
        handler: function () {
          if (this.upload.kk) {
            this.process.kk = this.upload.kk.process

            if (!this.process.kk) {
              // CALLBACK FROM UPLOAD DOC
              
              this.form.kk = this.upload.kk.fileuri
            }
          }
        },
        deep: true
      },
      'upload.npwp': {
        handler: function () {
          if (this.upload.npwp) {
            this.process.npwp = this.upload.npwp.process

            if (!this.process.npwp) {
              // CALLBACK FROM UPLOAD DOC
              
              this.form.npwp = this.upload.npwp.fileuri
            }
          }
        },
        deep: true
      },
      'upload.bpjs_kesehatan': {
        handler: function () {
          if (this.upload.bpjs_kesehatan) {
            this.process.bpjs_kesehatan = this.upload.bpjs_kesehatan.process

            if (!this.process.bpjs_kesehatan) {
              // CALLBACK FROM UPLOAD DOC
              
              this.form.bpjs_kesehatan = this.upload.bpjs_kesehatan.fileuri
            }
          }
        },
        deep: true
      },
      'upload.bpjs_ketenagakerjaan': {
        handler: function () {
          if (this.upload.bpjs_ketenagakerjaan) {
            this.process.bpjs_ketenagakerjaan = this.upload.bpjs_ketenagakerjaan.process

            if (!this.process.bpjs_ketenagakerjaan) {
              // CALLBACK FROM UPLOAD DOC
              
              this.form.bpjs_ketenagakerjaan = this.upload.bpjs_ketenagakerjaan.fileuri
            }
          }
        },
        deep: true
      }
    },
    mounted () {
      
    },
    methods: {
      reset () {
        if (this.$refs.form_doc) this.$refs.form_doc.reset()
        
        this.$emit('close', false)

        this.process.form = false

        this.message.error = ''
      },
      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form_doc.validate()

        if (isValid) {
          this.process.form = true

          // SAVE TO REST API
          await post('admin/user/upload_doc', {
            data: this.form
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.$emit('snackbar', res.message)
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form_doc.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form_doc.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>